import { useMutation } from 'react-query';

// import { useVpSnackbar } from '../vp-ui';
import api from '../../utils/api';
import { MEDIA_SUBMISSIONS } from '../../constants/endpoints';

const createMediaSubmission = ({ data }) => api.post(`${MEDIA_SUBMISSIONS}/clp`, data);
export const useCreateMediaSubmission = () => {
  return useMutation(createMediaSubmission);
};

const patchMediaSubmission = ({ mediaSubmissionId, payload }) =>
  api.patch(`${MEDIA_SUBMISSIONS}/${mediaSubmissionId}`, payload);
export const usePatchMediaSubmission = () => {
  return useMutation(patchMediaSubmission)
};



// WEBPACK FOOTER //
// ./src/hooks/react-query/useMediaSubmissionData.js